import type { ListItemStateType } from './Item'

export type NestedListActions =
  | { type: NestedListActionTypes.RegisterListId; id: string }
  | { type: NestedListActionTypes.ToggleOpen }
  | { type: NestedListActionTypes.UnregisterListId }
  | {
      type: NestedListActionTypes.UpdateItemState
      itemState: ListItemStateType
    }

export enum NestedListActionTypes {
  RegisterListId,
  UnregisterListId,
  ToggleOpen,
  UpdateItemState,
}
